<template>
  <div class="loader" @click="enter">
    <img src="../assets/images/loader.svg" alt="Neurometronomy">
  </div>
</template>

<script>
export default {
  methods: {
    enter() {
      this.$emit('done');
    }
  },

  mounted() {
    setTimeout(() => {
      this.$emit('done');
    }, 20000);
  }
}
</script>

<style lang="scss" scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 5;
  background-color: white;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
}
</style>
